import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum bulkBeneficiaryFileType {
    UPLOAD_BULK_BENEFICIARY_FILE = "@@auth/UPLOAD_BULK_BENEFICIARY_FILE",
    UPLOAD_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/UPLOAD_BULK_BENEFICIARY_FILE_SUCCESS",
    UPLOAD_BULK_BENEFICIARY_FILE_ERROR = "@@auth/UPLOAD_BULK_BENEFICIARY_FILE_ERROR",
    RESET_UPLOAD_BULK_BENEFICIARY_FILE = "@@auth/RESET_UPLOAD_BULK_BENEFICIARY_FILE",

    FETCH_BULK_BENEFICIARY_FILE = "@@auth/FETCH_BULK_BENEFICIARY_FILE",
    FETCH_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/FETCH_BULK_BENEFICIARY_FILE_SUCCESS",
    FETCH_BULK_BENEFICIARY_FILE_ERROR = "@@auth/FETCH_BULK_BENEFICIARY_FILE_ERROR",
    RESET_FETCH_BULK_BENEFICIARY_FILE = "@@auth/RESET_FETCH_BULK_BENEFICIARY_FILE",

    BULK_BENEFICIARY_FILE_DOWNLOAD = "@@auth/BULK_BENEFICIARY_FILE_DOWNLOAD",
    BULK_BENEFICIARY_FILE_DOWNLOAD_SUCCESS = "@@auth/BULK_BENEFICIARY_FILE_DOWNLOAD_SUCCESS",
    BULK_BENEFICIARY_FILE_DOWNLOAD_ERROR = "@@auth/BULK_BENEFICIARY_FILE_DOWNLOAD_ERROR",
    RESET_BULK_BENEFICIARY_FILE_DOWNLOAD = "@@auth/RESET_BULK_BENEFICIARY_FILE_DOWNLOAD",

    FETCH_BULK_BENEFICIARY_FILE_DETAIL = "@@auth/FETCH_BULK_BENEFICIARY_FILE_DETAIL",
    FETCH_BULK_BENEFICIARY_FILE_DETAIL_SUCCESS = "@@auth/FETCH_BULK_BENEFICIARY_FILE_DETAIL_SUCCESS",
    FETCH_BULK_BENEFICIARY_FILE_DETAIL_ERROR = "@@auth/FETCH_BULK_BENEFICIARY_FILE_DETAIL_ERROR",
    RESET_FETCH_BULK_BENEFICIARY_FILE_DETAIL = "@@auth/RESET_FETCH_BULK_BENEFICIARY_FILE_DETAIL",

    BULK_BENEFICIARY_FILE_VERSION = "@@auth/BULK_BENEFICIARY_FILE_VERSION",
    BULK_BENEFICIARY_FILE_VERSION_SUCCESS = "@@auth/BULK_BENEFICIARY_FILE_VERSION_SUCCESS",
    BULK_BENEFICIARY_FILE_VERSION_ERROR = "@@auth/BULK_BENEFICIARY_FILE_VERSION_ERROR",
    RESET_BULK_BENEFICIARY_FILE_VERSION = "@@auth/RESET_BULK_BENEFICIARY_FILE_VERSION",

    PUBLISH_BULK_BENEFICIARY_FILE = "@@auth/BULK_BENEFICIARY_FILE_PUBLISH",
    PUBLISH_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/PUBLISH_BULK_BENEFICIARY_FILE_SUCCESS",
    PUBLISH_BULK_BENEFICIARY_FILE_ERROR = "@@auth/PUBLISH_BULK_BENEFICIARY_FILE_ERROR",
    RESET_PUBLISH_BULK_BENEFICIARY_FILE = "@@auth/RESET_PUBLISH_BULK_BENEFICIARY_FILE",

    APPROVE_BULK_BENEFICIARY_FILE = "@@auth/APPROVE_BULK_BENEFICIARY_FILE",
    APPROVE_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/APPROVE_BULK_BENEFICIARY_FILE_SUCCESS",
    APPROVE_BULK_BENEFICIARY_FILE_ERROR = "@@auth/APPROVE_BULK_BENEFICIARY_FILE_ERROR",
    RESET_APPROVE_BULK_BENEFICIARY_FILE = "@@auth/RESET_APPROVE_BULK_BENEFICIARY_FILE",

    REJECT_BULK_BENEFICIARY_FILE = "@@auth/REJECT_BULK_BENEFICIARY_FILE",
    REJECT_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/REJECT_BULK_BENEFICIARY_FILE_SUCCESS",
    REJECT_BULK_BENEFICIARY_FILE_ERROR = "@@auth/REJECT_BULK_BENEFICIARY_FILE_ERROR",
    RESET_REJECT_BULK_BENEFICIARY_FILE = "@@auth/RESET_REJECT_BULK_BENEFICIARY_FILE",

    FETCH_BULK_FILE_SPECIFIC_BENEFICIARY = "@@auth/FETCH_BULK_FILE_SPECIFIC_BENEFICIARY",
    FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_SUCCESS = "@@auth/FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_SUCCESS",
    FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_ERROR = "@@auth/FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_ERROR",
    RESET_FETCH_BULK_FILE_SPECIFIC_BENEFICIARY = "@@auth/RESET_FETCH_BULK_FILE_SPECIFIC_BENEFICIARY",

    DELETE_BULK_BENEFICIARY_FILE = "@@auth/DELETE_BULK_BENEFICIARY_FILE",
    DELETE_BULK_BENEFICIARY_FILE_SUCCESS = "@@auth/DELETE_BULK_BENEFICIARY_FILE_SUCCESS",
    DELETE_BULK_BENEFICIARY_FILE_ERROR = "@@auth/DELETE_BULK_BENEFICIARY_FILE_ERROR",
    RESET_DELETE_BULK_BENEFICIARY_FILE = "@@auth/RESET_DELETE_BULK_BENEFICIARY_FILE",
}

// Action Types
export type BulkBeneficiaryFileAction = {
    type:
    | bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_UPLOAD_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD
    | bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_DOWNLOAD

    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE_DETAIL

    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION
    | bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_VERSION

    | bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_PUBLISH_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_APPROVE_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_REJECT_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_FILE_SPECIFIC_BENEFICIARY

    | bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.RESET_DELETE_BULK_BENEFICIARY_FILE;

    payload: any;
};

export type uploadBulkBeneficiaryFileType = {
    bulkBeneficiaryFile: File;
}

export type BulkBeneficiaryDownloadFileType = {
    downloadURL: string
}
export type BulkBeneficiaryFileDetail = {
    externalID: string,
}
export type BulkBeneficiaryFileVersionType = {
    externalId: string,
    filter: FilterMetadata
}
export type BulkBeneficiaryFileMakerRemarkType = {
    remarkPayload: { makerRemarks: string },
    externalId: string
}
export type BulkBeneficiaryFileCheckerRemarkType = {
    remarkPayload: { checkerRemarks: string },
    externalId: string
}


// Saga Types
export type uploadBulkBeneficiaryFileSaga = {
    type: string,
    payload: uploadBulkBeneficiaryFileType
}

export type fetchBulkBeneficiaryFileSaga = {
    type: string,
    payload: FilterMetadata
}
export type downloadBulkBeneficiaryFileSaga = {
    type: string,
    payload: BulkBeneficiaryDownloadFileType
}
export type fetchBulkBeneficiaryFileDetailSaga = {
    type: string,
    payload: BulkBeneficiaryFileDetail
}
export type BulkBeneficiaryFileVersionSaga = {
    type: string,
    payload: BulkBeneficiaryFileVersionType
}
export type BulkBeneficiaryFileMakerRemarkSaga = {
    type: string,
    payload: BulkBeneficiaryFileMakerRemarkType
}
export type BulkBeneficiaryFileCheckerRemarkSaga = {
    type: string,
    payload: BulkBeneficiaryFileCheckerRemarkType
}



// Reducer Types
type reducerPayload = {
    data: FetchApiResponse<bulkBeneficiary>; // Future option: FetchApiResponse<any> | Record<string, unknown>
    error: string;
}

export type BulkBeneficiaryFileReducer = {
    type:
    | bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.UPLOAD_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_UPLOAD_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD
    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_SUCCESS
    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_DOWNLOAD_ERROR
    | bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_DOWNLOAD

    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL
    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_SUCCESS
    | bulkBeneficiaryFileType.FETCH_BULK_BENEFICIARY_FILE_DETAIL_ERROR
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_BENEFICIARY_FILE_DETAIL

    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION
    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_SUCCESS
    | bulkBeneficiaryFileType.BULK_BENEFICIARY_FILE_VERSION_ERROR
    | bulkBeneficiaryFileType.RESET_BULK_BENEFICIARY_FILE_VERSION

    | bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.PUBLISH_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_PUBLISH_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.APPROVE_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_APPROVE_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.REJECT_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_REJECT_BULK_BENEFICIARY_FILE

    | bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY
    | bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_SUCCESS
    | bulkBeneficiaryFileType.FETCH_BULK_FILE_SPECIFIC_BENEFICIARY_ERROR
    | bulkBeneficiaryFileType.RESET_FETCH_BULK_FILE_SPECIFIC_BENEFICIARY

    | bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE
    | bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_SUCCESS
    | bulkBeneficiaryFileType.DELETE_BULK_BENEFICIARY_FILE_ERROR
    | bulkBeneficiaryFileType.RESET_DELETE_BULK_BENEFICIARY_FILE

    payload: reducerPayload;
};

export type BulkBeneficiaryFileReducerStateWithoutListObject = {
    loading?: boolean;
    data?: bulkBeneficiary | null;
    error?: string | null;
};
export type BulkBeneficiaryFileReducerStateWithListObject = {
    loading?: boolean;
    data?: FetchApiResponse<bulkBeneficiary>;
    error?: string | null;
};


export type bulkBeneficiary = {
    checkerRemarks: string;
    count: number;
    actionByUserRecord: actionByUserRecord;
    createdOn: number;
    draft: boolean;
    errorText: string;
    externalId: string;
    financierId: string;
    id: string;
    inputFilePath: string;
    makerRemarks: string;
    module: string;
    outputFilePath: string;
    status: string;
    updatedOn: number;
}

type actionByUserRecord = {
    id: string;
    externalId: string;
    name: string;
    email: string;
} 